import { EntityImageManager } from '@/components/entity-image-manager';
import { useSubscription } from '@/hooks/useSubscription';
import type { Codex, ProcessedImage } from '@/lib/types';

interface ImageManagerProps {
  onUpdate: (updates: { images?: ProcessedImage[], pendingFiles?: File[], primaryImageId?: string | null }) => void;
  entry: Codex;
  pendingFiles?: File[];
  isProcessing?: boolean;
  visualDescription?: string;
  onVisualDescriptionChange?: (value: string) => void;
}

export function ImageManager({
  onUpdate,
  entry,
  pendingFiles,
  isProcessing = false,
  visualDescription,
  onVisualDescriptionChange
}: ImageManagerProps) {
  const { hasFeature, isTokenDepleted } = useSubscription();
  const canCreateAIImages = hasFeature('can_create_ai_images');

  return (
    <EntityImageManager
      type="codex"
      images={entry.images || []}
      primaryImageId={entry.primaryImageId ?? null}
      onUpdate={onUpdate}
      pendingFiles={pendingFiles}
      isProcessing={isProcessing}
      entityId={entry.id}
      canCreateAIImages={canCreateAIImages}
      isTokenDepleted={isTokenDepleted}
      visualDescription={visualDescription}
      onVisualDescriptionChange={onVisualDescriptionChange}
    />
  );
}
